import State from "../state"
import { PlanningParams } from "./types"

export const getPlanningParams = (state: State): PlanningParams => state.planningParams.data.planning
export const getAbsencesParams = (state: State): PlanningParams => state.planningParams.data.absences
